import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import classNames from "classnames";

import stringUtils from "../../utils/string";
import BaseModal from "../Modals/BaseModal";
import AccountSearchSelectList from "../SelectLists/Types/AccountSearchSelectList";
import ProductGroupSearchSelectList from "../SelectLists/Types/ProductGroupSearchSelectList";
import OpportunitySearchSelectList from "../SelectLists/Types/OpportunitySearchSelectList";
import ServiceRequestSearchSelectList from "../SelectLists/Types/ServiceRequestSearchSelectList";
import MODAL_SETTINGS from "../../styles/modalSettings";

import {
  closeFilterModal,
  refreshEntries,
  setHistoryFilters
} from "../../actions/historyActions";

import CategoryList from "./CategoryList";
import InterlockList from "./InterlockList";

// SASS Imports
require("./Filters.scss");

export class Filters extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeSlide: 0,
      activeFilter: "accountFilter",
      selectedFilters: this.props.filters,
      version: this.props.version,
    };
    this.onRequestClose = this.onRequestClose.bind(this);
    this.filterOptionRow = this.filterOptionRow.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.version !== state.version && !_.isEqual(props.filters, state.selectedFilters)) {
      return { selectedFilters: props.filters, version: props.version };
    }

    return null;
  }

  onRequestClose () {
    this.setState({activeSlide: 0});
    this.props.onRequestClose();
  }

  filterOptionRow (optionName, label, attribute) {
    const filterIsActive = Boolean(this.state.selectedFilters[optionName]);

    const btnClasses = classNames("btn", "btn-default", "btn-filter-option", {
      "col-xs-10": filterIsActive,
      "col-xs-12": !filterIsActive,
    });

    const onClickButton = () => {
      this.setState({ activeSlide: 1, activeFilter: `${optionName}Filter` });
    };

    const buttonText = filterIsActive ?
      stringUtils.truncate(`${label}: ${this.state.selectedFilters[optionName][attribute]}`, 28) :
      label
    ;

    const onClickClear = () => {
      const { selectedFilters: currentFilters } = this.state;

      const selectedFilters = { ...currentFilters, [optionName]: null };

      this.setState({ selectedFilters });
    };

    return (
      <div className="row">
        <div className={(filterIsActive) ? "btn-group active btn-block" : "btn-group btn-block"}>
          <button className={btnClasses} onClick={onClickButton}>{buttonText}</button>

          {filterIsActive && <button onClick={onClickClear} className="btn col-xs-2 btn-primary btn-cancel">&times;</button>}
        </div>
      </div>
    );
  }

  _isActive (filter) {
    return (this.state.activeFilter === `${filter}Filter`)
      && (this.state.activeSlide > 0);
  }

  render () {
    let categoryFilterActive = this._isActive("category");
    let accountFilterActive = this._isActive("account");
    let productGroupFilterActive = this._isActive("productGroup");
    let opportunityFilterActive = this._isActive("opportunity");
    let serviceRequestFilterActive = this._isActive("serviceRequest");
    let interlockFilterActive = this._isActive("interlock");

    let modalStyles = {};
    let modalContainerClass = "searchListModal";

    if (this.state.activeSlide === 0) {
      modalStyles = {
        content: {...MODAL_SETTINGS.content, maxWidth: "400px"}
      };
      modalContainerClass = "filterModal";
    }

    return (
      <BaseModal
        title="Filters"
        isOpen={this.props.isFiltersOpen}
        onRequestClose={this.onRequestClose}
        renderWithHeader={false}
        containerClass= {modalContainerClass}
        style= {modalStyles}
      >
        <div className="modalHeader">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-3 filterBack">
                {(this.state.activeSlide > 0) && <button
                  className="btn-add"
                  onClick={() => this.setState({activeSlide: 0})}
                >Back</button>}
              </div>
              <div className="col-xs-6 text-center">
                <h4>Filters</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="modalContent">
          {this.state.activeSlide == 0 && <div
            className={"filterOptions " +
                ((this.state.activeSlide === 0) ? "" : "hidden")}
          >
            <div className="container-fluid">
              <div className="col-md-12">
                {this.filterOptionRow("category", "Activity", "name")}
                {this.filterOptionRow("account", "Account", "accountName")}
                {this.filterOptionRow("productGroup", "Product Group", "productGroupDescr")}
                {this.filterOptionRow("opportunity", "Opportunity", "opportunityName")}
                {this.filterOptionRow("serviceRequest", "Service Request", "srNumber")}
                {this.filterOptionRow("interlock", "Interlock", "interlockName")}

                <div className="row">
                  <p className="filterSubmit">
                    <button
                      className="btn-submit"
                      onClick={() => this.props.setFilters(this.state.selectedFilters)}
                    >Apply</button>
                  </p>
                </div>
              </div>
            </div>
          </div>}

          {categoryFilterActive && <CategoryList
            onSelectItem={(category) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  category
                }
              });
            }}
          />}

          {accountFilterActive && <AccountSearchSelectList
            onSelectItem={(account) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  account
                }
              });
            }}
          />}

          {productGroupFilterActive && <ProductGroupSearchSelectList
            onSelectItem={(productGroup) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  productGroup
                }
              });
            }}
          />}

          {opportunityFilterActive && <OpportunitySearchSelectList
            onSelectItem={(opportunity) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  opportunity
                }
              });
            }}
          />}

          {serviceRequestFilterActive && <ServiceRequestSearchSelectList
            onSelectItem={(serviceRequest) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  serviceRequest
                }
              });
            }}
          />}

          {interlockFilterActive && <InterlockList
            onSelectItem={(interlock) => {
              this.setState({
                activeSlide: 0,
                selectedFilters: {
                  ...this.state.selectedFilters,
                  interlock
                }
              });
            }}
          />}

        </div>
      </BaseModal>
    )
  }
}

Filters.displayName = "History.Filters";

Filters.propTypes = {

};

function mapStateToProps (state) {
  return {
    filters: state.historyFilters.filters,
    version: state.historyFilters.version || 0,
    isFiltersOpen: state.historyFilters.modalOpen,
  };
}

function mapDispatchToProps (dispatch) {
  return {
    onRequestClose() {
      dispatch(closeFilterModal());
    },
    setFilters(filters) {
      dispatch(setHistoryFilters(filters));

      dispatch(closeFilterModal());

      dispatch(refreshEntries());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./app/components/History/Filters.jsx